
export class ChartConfig {
    static PieChartBaseColors = ["#ff8779", "#2a84e9", "#e2e2e2"];
    static ChartType = {
        "LINE":"line",
        "BAR":"bar"
    };
    static ConfigColors = {
        'RED':"red",
        'PURPLE':"purple",
        'BLUE':"blue",
        'PINK':"pink"
    };
    static GradientChartOptions = {
        'gradientChartOptionsConfigurationWithTooltipRed':'gradientChartOptionsConfigurationWithTooltipRed',
        'gradientChartOptionsConfigurationPurple':'gradientChartOptionsConfigurationPurple',
        'gradientChartOptionsConfigurationBlue':'gradientChartOptionsConfigurationBlue',
        'gradientBarChartConfiguration':'gradientBarChartConfiguration'
    };

    static getLineOrBarConfig(type:string, xAxisLabels:string[], gradientStroke, color:string = this.ConfigColors.RED, gradientChartOption:string = this.GradientChartOptions.gradientBarChartConfiguration){
        let config = {
            type: type,
            data: {
                labels: xAxisLabels,
                datasets: [
                    // Ha ebből tőbb van, akkor több diagram jelenik meg a diagramon
                    this.getDatasetConfig(type, gradientStroke, color)
                ]
            },
            options: this.getGradientChartOption(type, gradientChartOption)
        };
        return config;
    }

    static getPieChartConfig(data:number[], colors?:string[]){
        let chartColors = [];

        if(colors == undefined || colors.length == 0) colors = this.PieChartBaseColors;
        if(data.length <= colors.length){
            chartColors = colors;
        } else {
            for(let i = 0; i < data.length; i++){
                chartColors.push(colors[i % colors.length])
            }
        }

        let config = {
            type: "pie",
            data: {
                labels: [], // Component állítja
                datasets: [
                    {
                        label: "Emails",
                        pointRadius: 0,
                        pointHoverRadius: 0,
                        backgroundColor: chartColors,
                        borderWidth: 0,
                        data: data
                    }
                ]
            },
            options: {
                cutoutPercentage: 70,
                legend: {
                    display: false
                },

                tooltips: {
                    backgroundColor: "#f5f5f5",
                    titleFontColor: "#333",
                    bodyFontColor: "#666",
                    bodySpacing: 4,
                    xPadding: 12,
                    mode: "nearest",
                    intersect: 0,
                    position: "nearest"
                },

                scales: {
                    yAxes: [
                        {
                            display: 0,
                            ticks: {
                                display: false
                            },
                            gridLines: {
                                drawBorder: false,
                                zeroLineColor: "transparent",
                                color: "rgba(255,255,255,0.05)"
                            }
                        }
                    ],

                    xAxes: [
                        {
                            display: 0,
                            barPercentage: 1.6,
                            gridLines: {
                                drawBorder: false,
                                color: "rgba(255,255,255,0.1)",
                                zeroLineColor: "transparent"
                            },
                            ticks: {
                                display: false
                            }
                        }
                    ]
                }
            }
        };
        return config;
    }

    private static getDatasetConfig = function(type:string, gradientStroke, color:string = this.ConfigColors.RED){
        let borderColor = "#ec250d";
        let pointBackgroundColor = "#ec250d";
        let pointBorderColor = "rgba(255,255,255,0)";
        let pointHoverBackgroundColor = "#ec250d";
        switch (color) {
            case this.ConfigColors.RED:
                borderColor = "#ec250d";
                pointBackgroundColor = "#ec250d";
                pointBorderColor = "rgba(255,255,255,0)";
                pointHoverBackgroundColor = "#ec250d";

                if(type == this.ChartType.LINE) {
                    gradientStroke.addColorStop(1, "rgba(233,32,16,0.2)");
                    gradientStroke.addColorStop(0.4, "rgba(233,32,16,0.0)");
                    gradientStroke.addColorStop(0, "rgba(233,32,16,0)");
                } else {
                    gradientStroke.addColorStop(1, "rgba(233,32,16,0.8)");
                    gradientStroke.addColorStop(0, "rgba(233,32,16,0)");
                }

                break;

            case this.ConfigColors.PURPLE:
                borderColor = "#ba54f5";
                pointBackgroundColor = "#be55ed";
                pointBorderColor = "rgba(255,255,255,0)";
                pointHoverBackgroundColor = "#be55ed";

                if(type == this.ChartType.LINE) {
                    gradientStroke.addColorStop(1, "rgba(72,72,176,0.2)");
                    gradientStroke.addColorStop(0.4, "rgba(72,72,176,0.0)");
                    gradientStroke.addColorStop(0, "rgba(72,72,176,0)");
                } else {
                    gradientStroke.addColorStop(1, "rgba(72,72,176,0.8)");
                    gradientStroke.addColorStop(0, "rgba(72,72,176,0)");
                }

                break;

            case this.ConfigColors.BLUE:
                borderColor = "#2380f7";
                pointBackgroundColor = "#2380f7";
                pointBorderColor = "rgba(255,255,255,0)";
                pointHoverBackgroundColor = "#2380f7";

                if(type == this.ChartType.LINE) {
                    gradientStroke.addColorStop(1, "rgba(0,135,191,0.2)");
                    gradientStroke.addColorStop(0.4, "rgba(0,135,191,0.0)");
                    gradientStroke.addColorStop(0, "rgba(0,135,191,0)");
                } else {
                    gradientStroke.addColorStop(1, "rgba(0,135,191,0.8)");
                    gradientStroke.addColorStop(0, "rgba(0,135,191,0)");
                }

                break;

            case this.ConfigColors.PINK:
                borderColor = "#ff5991";
                pointBackgroundColor = "#ff5991";
                pointBorderColor = "rgba(255,255,255,0)";
                pointHoverBackgroundColor = "#ff5991";

                if(type == this.ChartType.LINE) {
                    gradientStroke.addColorStop(1, "rgba(253,93,147,0.2)");
                    gradientStroke.addColorStop(0.4, "rgba(253,93,147,0.0)");
                    gradientStroke.addColorStop(0, "rgba(253,93,147,0)");
                } else {
                    gradientStroke.addColorStop(1, "rgba(253,93,147,0.8)");
                    gradientStroke.addColorStop(0, "rgba(253,93,147,0)");
                }

                break;
        }

        let dataset = {};
        if(type == this.ChartType.LINE){
            dataset = {
                label: "My First dataset",
                fill: true,
                backgroundColor: gradientStroke,
                borderColor: borderColor,
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: pointBackgroundColor,
                pointBorderColor: pointBorderColor,
                pointHoverBackgroundColor: pointHoverBackgroundColor,
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: []
            };
        } else if(type == this.ChartType.BAR){
            dataset = {
                label: "My First dataset",
                fill: true,
                backgroundColor: gradientStroke,
                hoverBackgroundColor: gradientStroke,
                borderColor: borderColor,
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                data: []
            };
        }
        return dataset;
    };

    private static getGradientChartOption = function (type:string, color: string = this.GradientChartOptions.gradientBarChartConfiguration) {
        let backgroundColor = "#f5f5f5";
        let titleFontColor = "#333";
        let bodyFontColor = "#666";
        let colorY;
        let fontColorY = "#9a9a9a";
        let colorX;
        let fontColorX = "#9a9a9a";
        let barPercentage = type == this.ChartType.BAR ? 1.0 : 1.6;

        switch (color) {
            case this.GradientChartOptions.gradientChartOptionsConfigurationWithTooltipRed:
                colorY = "rgba(29,140,248,0.0)";
                colorX = "rgba(233,32,16,0.1)";
                break;
            case this.GradientChartOptions.gradientChartOptionsConfigurationPurple:
                colorY = "rgba(186,84,245,0.1)";
                colorX = "rgba(186,84,245,0.1)";
                break;
            case this.GradientChartOptions.gradientChartOptionsConfigurationBlue:
                colorY = "rgba(29,140,248,0.0)";
                colorX = "rgba(29,140,248,0.1)";
                break;
            case this.GradientChartOptions.gradientBarChartConfiguration:
                colorY = "rgba(253,93,147,0.1)";
                colorX = "rgba(253,93,147,0.1)";
                break;

        }

        let chartOption = {
            maintainAspectRatio: false,
            legend: {
                display: false
            },

            tooltips: {
                backgroundColor: backgroundColor,
                titleFontColor: titleFontColor,
                bodyFontColor: bodyFontColor,
                bodySpacing: 4,
                xPadding: 12,
                mode: "nearest",
                intersect: 0,
                position: "nearest"
            },
            responsive: true,
            scales: {
                yAxes: [
                    {
                        barPercentage: barPercentage,
                        gridLines: {
                            drawBorder: false,
                            color: colorY,
                            zeroLineColor: "transparent"
                        },
                        ticks: {
                            suggestedMin: 0,    // Y tengely skálájának javasolt kezdete és vége -> componensből van állítva
                            suggestedMax: 120,
                            padding: 20,
                            fontColor: fontColorY
                        }
                    }
                ],

                xAxes: [
                    {
                        barPercentage: barPercentage,
                        gridLines: {
                            drawBorder: false,
                            color: colorX,
                            zeroLineColor: "transparent"
                        },
                        ticks: {
                            padding: 20,
                            fontColor: fontColorX
                        }
                    }
                ]
            }
        };
        return chartOption;
    }
}
